module.exports = __webpack_public_path__ + "static/course-banner-57ece5532a7ca1d45a6fb03712a75c15.png";